/**
 * Il riordino durante il trascinamento.
 *
 * Mentre si trascina un widget, l'ordine cambia dal vivo: la griglia vera si
 * risistema e mostra dove andra' a finire. Due regole evitano lo
 * "sfarfallio": se non cambia niente si restituisce la stessa lista (niente
 * ridisegno inutile), e si riordina di nuovo solo se il puntatore si e'
 * davvero mosso, non perche' la griglia si e' spostata sotto di lui.
 */

export interface Punto {
  x: number;
  y: number;
}

/** Soglia di movimento, in pixel, prima di un nuovo riordino. */
export const SOGLIA_MOVIMENTO = 8;

/** Mette `attivo` al posto di `sopra`. Stessa lista se non cambia niente. */
export function spostaSopra(ids: readonly string[], attivo: string, sopra: string): readonly string[] {
  const da = ids.indexOf(attivo);
  const a = ids.indexOf(sopra);
  if (da < 0 || a < 0 || da === a) return ids;
  const senza = ids.filter((id) => id !== attivo);
  return [...senza.slice(0, a), attivo, ...senza.slice(a)];
}

/**
 * Vero se il puntatore si e' mosso di almeno `soglia` pixel dall'ultimo
 * riordino. Senza posizione (trascinamento da tastiera, o primo riordino)
 * e' sempre vero.
 */
export function puntatoreMosso(prima: Punto | null, adesso: Punto | null, soglia = SOGLIA_MOVIMENTO): boolean {
  if (!prima || !adesso) return true;
  return Math.hypot(adesso.x - prima.x, adesso.y - prima.y) >= soglia;
}
